import { map } from 'lodash';

export const splitAndMapArrayParam = (rawValue, mapIterator) => {
  if (typeof rawValue !== 'string') {
    return rawValue;
  }
  const arrayValue = rawValue.split('/');
  if (typeof mapIterator !== 'function') {
    return arrayValue;
  }
  return map(arrayValue, mapIterator);
};
